import { colors, Skeleton, styled, TableCell, TableRow } from "@mui/material";
import { tableCellClasses } from '@mui/material/TableCell';
import { tableRowClasses } from '@mui/material/TableRow';
import { useEffect, useRef, useState } from "react";

const TableCellRate = ({ rate, currency, fractionDigits = 2, isLoading = false, bgColor = colors.grey[100], skeletonWidth = 100 }) => {

  function formatRate(rate) {
    if (rate === '-') {
      return rate;
    }

    if (isNaN(rate) || rate == 'Unavailable' || typeof rate === 'string') {
      return <span style={{ color: '#f44336' }}>{'Unavailable'}</span>
    }

    if (isNaN(rate)) {
      return rate;
    }

    return getCurrencySign() + rate.toLocaleString('en-PH', { minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits });
  }

  function getCurrencySign() {
    if (currency === 'USD') {
      return '$';
    } else if (currency === 'EURO') {
      return '€';
    } else if (currency === 'GBP') {
      return '£';
    } else if (currency === 'SGD') {
      return 'S$';
    }

    return '';
  }

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.body}`]: {
      border: '2px solid #fff',
      backgroundColor: bgColor,
    },
  }));

  return isLoading ? <StyledTableCell><Skeleton variant="rounded" width={skeletonWidth} height={20} /></StyledTableCell>
    : <StyledTableCell>{formatRate(rate)}</StyledTableCell>;
};

export default TableCellRate;